import React, {useState} from 'react';
import { Controller } from 'react-hook-form';
import _ from 'lodash';
import clsx from 'clsx';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form'
import SubgroupSelect from './SubgroupSelect';
import { groupByDisabled } from 'utils/select';

export default function CohortSelect({accesses}) {
  const methods = useFormContext()
  const [opened, setOpened] = useState(!!methods.formState.errors.subgroup_ids)
  const toggle = (event) => {
    event.preventDefault()
    event.stopPropagation()

    setOpened(!opened)
  }

  return (
    <>
      <div>
        <span className='u-txt--label'>Cohorts</span><br />
        <Controller
          name='cohort_ids'
          control={methods.control}
          render={({ field: { onChange, value } }) => (
            <Select
              isMulti
              name='sp-group-select'
              className={clsx('o-select o-select--optgroup', { 'o-select--error': _.get(methods.formState.errors, 'cohort_ids') })}
              value={(accesses.data?.cohorts ?? []).filter(o => (value || []).includes(o.value))}
              onChange={(v) => {
                onChange(v.map(v => v.value));
              }}
              options={groupByDisabled(accesses.data?.cohorts ?? [])}
            />
          )}
        />
        {methods.formState.errors.cohort_ids && (<p className='u-txt--error'>{methods.formState.errors.cohort_ids.message}</p>)}
      </div>
      <div>
        <a href='#' onClick={toggle}>
          <span style={{marginRight: '8px'}}>
            {opened ? <i className='fa fa-chevron-down'></i> : <i className='fa fa-chevron-right'></i>}
          </span>
          Give higher level access
        </a>
        <div style={{marginLeft: '16px'}}>
          {opened && (
            <p>
              <SubgroupSelect accesses={accesses} />
            </p>
          )}
        </div>
      </div>
    </>
  )
}

CohortSelect.propTypes = {
  accesses: PropTypes.object.isRequired,
};
